export default {
  auth: process.env.REACT_APP_SENTRY_DSN_AUTH,
  dashboard: process.env.REACT_APP_SENTRY_DSN_DASHBOARD,
  transactions: process.env.REACT_APP_SENTRY_DSN_TRANSACTIONS,
  points: process.env.REACT_APP_SENTRY_DSN_POINTS,
  allies: process.env.REACT_APP_SENTRY_DSN_ALLIES,
  referrals: process.env.REACT_APP_SENTRY_DSN_REFERRALS,
  payments: process.env.REACT_APP_SENTRY_DSN_PAYMENTS,
  users: process.env.REACT_APP_SENTRY_DSN_USERS,
  cards: process.env.REACT_APP_SENTRY_DSN_CARDS,
  activity: process.env.REACT_APP_SENTRY_DSN_ACTIVITY,
  company: process.env.REACT_APP_SENTRY_DSN_COMPANY,
  digital_account_payments:
    process.env.REACT_APP_SENTRY_DSN_DIGITAL_ACCOUNT_PAYMENTS,
  services: process.env.REACT_APP_SENTRY_DSN_SERVICES,
  international_payments:
    process.env.REACT_APP_SENTRY_DSN_INTERNATIONAL_PAYMENTS,
  invoices: process.env.REACT_APP_SENTRY_DSN_INVOICES,
  reimbursements: process.env.REACT_APP_SENTRY_DSN_REIMBURSEMENTS,
  help_center: process.env.REACT_APP_SENTRY_DSN_HELP_CENTER,
  approvals_flow: process.env.REACT_APP_SENTRY_DSN_APPROVALS_FLOW,
  open_finance: process.env.REACT_APP_SENTRY_DSN_OPEN_FINANCE,
  payments_br: process.env.REACT_APP_SENTRY_DSN_PAYMENTS_BR,
  digital_account: process.env.REACT_APP_SENTRY_DSN_DIGITAL_ACCOUNT,
  digital_account_settings:
    process.env.REACT_APP_SENTRY_DSN_DIGITAL_ACCOUNT_SETTINGS,
  tasks: process.env.REACT_APP_SENTRY_DSN_TASKS,
  expenses_policies_settings:
    process.env.REACT_APP_SENTRY_DSN_EXPENSES_POLICIES_SETTINGS,
}
